import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography,
  Stack,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import LinkIcon from "@mui/icons-material/Link";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { FaXTwitter, FaInstagram, FaFacebookF, FaLinkedinIn, FaYoutube, FaTiktok } from "react-icons/fa6";
import { theme } from "../../theme/colors";

// Pick a recognizable icon by domain; fall back to a link icon for custom URLs.
function getLinkIcon(url) {
  const u = (url || "").toLowerCase();
  if (/(twitter\.com|x\.com)/.test(u)) return <FaXTwitter size={18} />;
  if (/instagram\.com/.test(u)) return <FaInstagram size={18} />;
  if (/facebook\.com/.test(u)) return <FaFacebookF size={18} />;
  if (/linkedin\.com/.test(u)) return <FaLinkedinIn size={18} />;
  if (/(youtube\.com|youtu\.be)/.test(u)) return <FaYoutube size={18} />;
  if (/tiktok\.com/.test(u)) return <FaTiktok size={18} />;
  return <LinkIcon sx={{ fontSize: 18 }} />;
}

export default function ProfileLinksModal({ open, onClose, links = [], displayName = "" }) {
  const title = displayName ? `More from ${displayName}` : "More links";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      aria-labelledby="profile-links-title"
      PaperProps={{ sx: { borderRadius: 3, p: 1 } }}
    >
      <IconButton
        onClick={onClose}
        aria-label="Close"
        size="small"
        sx={{ position: "absolute", top: 8, right: 8, color: "#0f172a" }}
      >
        <CloseIcon sx={{ fontSize: 18 }} />
      </IconButton>

      <DialogTitle
        id="profile-links-title"
        sx={{ textAlign: "center", pt: 2, pb: 0, px: 4 }}
      >
        <Typography
          component="h2"
          sx={{ fontWeight: 800, fontSize: 18, color: "#0f172a", lineHeight: 1.3 }}
        >
          {title}
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ pt: 1.5 }}>
        <Divider sx={{ mb: 2 }} />
        <Stack spacing={1}>
          {links.map((link, i) => (
            <Box
              key={`${link.url}-${i}`}
              component="a"
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                p: 1.5,
                borderRadius: 2,
                border: "1px solid #e5e7eb",
                bgcolor: "#fff",
                color: "#0f172a",
                textDecoration: "none",
                "&:hover": { bgcolor: "#f8fafc", borderColor: theme.primary },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 24,
                  flexShrink: 0,
                  color: theme.primary,
                }}
              >
                {getLinkIcon(link.url)}
              </Box>
              <Typography
                sx={{
                  flex: 1,
                  minWidth: 0,
                  fontSize: 15,
                  fontWeight: 600,
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  wordBreak: "break-word",
                }}
              >
                {link.title}
              </Typography>
              <OpenInNewIcon sx={{ fontSize: 16, color: "#0f172a", flexShrink: 0 }} />
            </Box>
          ))}
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
